import DialogPassengerCounter from "./DialogPassengerCounter";
import ErrorBalloon from "../../libs/ErrorBalloon";
import DialogPassengerAgeList from "./DialogPassengerAgeList";

export default class DialogPassengerRoom {
  static EVENT_DELETE = 'eventDelete';
  static EVENT_UPDATE_COUNT = 'eventUpdateCount';
  constructor(_index,_parent,_defaultData) {
    this.index = _index;

    this.el = document.createElement('div');

    this.target = document.createElement('div');
    this.target.classList.add('-room');

    let html = `
      <div class="-head"><h3>部屋<span>${_index + 1}</span></h3>${_index !== 0?`<button type="button" class="-js-delete">削除</button>`:''}</div>
        <dl class="-counter">
            <div class="-js-adt">
                <dt>大人(18歳以上)</dt>
            </div>
            <div class="-js-chd">
                <dt>子供(0~17歳)</dt>
            </div>
        </dl>
    `;
    this.target.innerHTML = html;
    _parent.appendChild(this.target);

    this.adtErrorMsg = new ErrorBalloon();
    this.adtErrorMsg.setArrowDirection(false);

    this.chdErrorMsg = new ErrorBalloon();
    this.chdErrorMsg.setArrowDirection(false);

    const baseZIndex = window.getComputedStyle(document.documentElement).getPropertyValue('--dialog-z-index');
    this.adtErrorMsg.target.style.zIndex = this.chdErrorMsg.target.style.zIndex = baseZIndex + 10;

    this.adtCount = new DialogPassengerCounter(this.target.querySelector('.-js-adt'),_defaultData.adtnum,1);
    this.chdCount = new DialogPassengerCounter(this.target.querySelector('.-js-chd'),_defaultData.chdnum);

    this.adtCount.el.addEventListener(DialogPassengerCounter.EVENT_UPDATE_COUNT,()=>{
      if(this.adtCount.tmpCount + this.chdCount.count <= 8){
        this.adtCount.updateCount();
        this.el.dispatchEvent(new CustomEvent(DialogPassengerRoom.EVENT_UPDATE_COUNT));
      } else {
        this.adtErrorMsg.show(this.adtCount.btnPlus,LtikeCommon.HOTEL.TEXT.MODAL_PASSENGER_ERROR4);
      }
    });
    this.chdCount.el.addEventListener(DialogPassengerCounter.EVENT_UPDATE_COUNT,()=>{
      if(this.chdCount.tmpCount + this.adtCount.count <= 8){
        this.chdCount.updateCount();
        this.ageList.updateCount(this.chdCount.count);
        this.el.dispatchEvent(new CustomEvent(DialogPassengerRoom.EVENT_UPDATE_COUNT));
      } else {
        this.chdErrorMsg.show(this.chdCount.btnPlus,LtikeCommon.HOTEL.TEXT.MODAL_PASSENGER_ERROR4);
      }
    });

    this.ageList = new DialogPassengerAgeList(this.target,_defaultData.chdage);

    this.target.querySelector('.-js-delete')?.addEventListener('click',this.onClickDelete.bind(this));
  }

  onClickDelete(){
    this.el.dispatchEvent(new CustomEvent(DialogPassengerRoom.EVENT_DELETE,{detail:{index:this.index}}));
  }

  onDialogClose(){
    this.adtErrorMsg.hide();
    this.chdErrorMsg.hide();
  }

  onDelete(){
    this.target.remove();
    this.adtErrorMsg.onDelete();
    this.adtErrorMsg = null;

    this.chdErrorMsg.onDelete();
    this.chdErrorMsg = null;
  }

  updateIndex(_index){
    this.index = _index;
    this.target.querySelector('h3 span').innerText = _index + 1;
  }
}
